import { createContext, useContext, useState, useEffect } from 'react';
import { getMe, logout as logoutService } from '../services/authService';
import logger from '../utils/logger';

/**
 * AMAÇ: Uygulama genelinde kullanıcı oturum bilgisini tutar
 * useAuth() hook'u ile her yerden erişilir
 */

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Sayfa yüklendiğinde token varsa kullanıcıyı getir
    const token = localStorage.getItem('streak_token');
    if (!token) { setLoading(false); return; }

    getMe()
      .then((res) => {
        setUser(res.user);
        logger.info('Oturum yüklendi', { userId: res.user.id });
      })
      .catch(() => { localStorage.removeItem('streak_token'); })
      .finally(() => setLoading(false));
  }, []);

  const logout = () => {
    logoutService();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
